//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FCSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    error: Boolean,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: true,
    },
  },
};
